import type { BasketWithActions } from '@/app/[locale]/(basket)'
import type { CheckoutModelInput } from '@/service-api/types.generated'
import type { ApiAddressSuggestion } from '@/types/address-suggestions'
import type { ICustomer } from '@/types/icustomer'
import { getURLFromPath } from '@/lib/freight'
import { formatAddressSuggestion } from '@/lib/address-suggestions'

type CheckoutModelProps = {
  basket: BasketWithActions
  user: ICustomer
  additionalInfo: string
  pickupDateBag: string
  pickupDateContainer: string
  deliveryDateContainer: string
  deliveryAddress?: ApiAddressSuggestion
  billingAddress?: ApiAddressSuggestion
  discountCode: string
  discountPercent: number
}

export const checkout = ({
  basket,
  user,
  additionalInfo,
  pickupDateBag,
  pickupDateContainer,
  deliveryDateContainer,
  deliveryAddress,
  billingAddress,
  discountCode,
  discountPercent,
}: CheckoutModelProps): CheckoutModelInput => {
  return {
    basketModel: basket.basketModel,
    customer: {
      firstName: user?.firstName,
      lastName: user?.lastName,
      addresses: [
        {
          type: 'delivery',
          email: user?.email,
          phone: user?.phone,
          street: deliveryAddress?.adressetekst,
          postalCode: deliveryAddress?.postnummer,
          city: deliveryAddress?.poststed,
          country: 'NO',
        },
        {
          type: 'billing',
          email: user?.email,
          phone: user?.phone,
          street: billingAddress?.adressetekst,
          postalCode: billingAddress?.postnummer,
          city: billingAddress?.poststed,
          country: 'NO',
        },
      ],
    },
    confirmationURL: getURLFromPath('/ordrebekreftelse/{crystallizeOrderId}?emptyBasket'),
    checkoutURL: getURLFromPath('/checkout'),
    termsURL: getURLFromPath('/vilkar'),
    meta: [
      { key: 'ServiceType', value: 'Pickup' },
      {
        key: 'deliveryAddress',
        value: deliveryAddress ? formatAddressSuggestion(deliveryAddress) : '',
      },
      {
        key: 'BillingAddress',
        value: billingAddress ? formatAddressSuggestion(billingAddress) : '',
      },
      {
        key: 'AdditionalInfo',
        value: additionalInfo ? additionalInfo.replace(/(\r\n|\n|\r)/gm, '') : '',
      },
      { key: 'PickupDateBag', value: pickupDateBag || '' },
      { key: 'PickupDateContainer', value: pickupDateContainer || '' },
      { key: 'DeliveryDateContainer', value: deliveryDateContainer || '' },
      { key: 'DiscountCode', value: discountCode || '' },
      { key: 'DiscountAmount', value: discountPercent ? discountPercent.toString() : '0' },
    ],
  }
}
